import { Navigate, Outlet } from "react-router-dom";
import type { AdminSection } from "../../../shared/index";
import { useAuth } from "@/contexts/auth-context";

/**
 * Wrap a route group with `<SectionGuard section="key">` (or pass children)
 * to require a specific admin section permission. Redirects to /dashboard
 * if the user lacks the permission.
 */
export function SectionGuard({ section }: { section: AdminSection }) {
  const { user } = useAuth();
  if (!user?.permissions[section]) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
